// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/images/WithName.png";
// import { AuthContext } from "../context/AuthContext";

// const about = [
//   { label: "Our Mission", path: "/mission" },
//   { label: "Our Vision", path: "/vision" },
//   { label: "Our Leadership Team", path: "/leadership-team" },
//   { label: "Our History", path: "/about" },
// ];

// const events = [
//   { label: "Upcoming Events", path: "/upcoming-events" },
//   { label: "Present Events", path: "/present-events" },
//   { label: "Past Events", path: "/past-events" },
// ];

// const facilities = [
//   { label: "Facilities for Guests", path: "/facilites-guests" },
//   { label: "Facilities for Members", path: "/facilites-members" },
// ];

// const content = [
//   { label: "Image Gallery", path: "/image-gallery" },
//   { label: "Video Gallery", path: "/video-gallery" },
// ];

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [aboutPagesOpen, setAboutPagesOpen] = useState(false);
//   const [eventPages, setEventPages] = useState(false);
//   const [facilitiesOpen, setFacilitiesOpen] = useState(false);
//   const [contentOpen, setContentOpen] = useState(false);

//   const { isLoggedIn } = useContext(AuthContext);

//   // Close all dropdowns when menu closes
//   const closeAllDropdowns = () => {
//     setAboutPagesOpen(false);
//     setEventPages(false);
//     setFacilitiesOpen(false);
//     setContentOpen(false);
//   };

//   const handleMenuToggle = () => {
//     const newMenuOpen = !menuOpen;
//     setMenuOpen(newMenuOpen);
//     if (!newMenuOpen) {
//       closeAllDropdowns();
//     }
//   };

//   const handleLinkClick = () => {
//     setMenuOpen(false);
//     closeAllDropdowns();
//   };

//   return (
//     <header className="fixed w-full z-50 left-0 top-0">
//       {/* Main Header */}
//       <div className="bg-gradient-to-r from-gray-900 to-black w-full backdrop-blur-lg px-4 sm:px-6 md:px-12 lg:px-16 py-4 md:py-3 flex items-center justify-between border-b border-gray-700">
//         {/* Logo - Properly aligned */}
//         <Link
//           to="/"
//           className="flex-shrink-0 flex items-center"
//           onClick={handleLinkClick}
//         >
//           <img
//             src={logo}
//             alt="RGCC Logo"
//             className="h-12 sm:h-14 md:h-16 w-auto object-contain"
//           />
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8 text-white font-medium">
//           <Link
//             to="/"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Home
//           </Link>

//           {/* About Us Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setAboutPagesOpen(true)}
//             onMouseLeave={() => setAboutPagesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap">
//               <span>About Us</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   aboutPagesOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 aboutPagesOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setAboutPagesOpen(true)}
//               onMouseLeave={() => setAboutPagesOpen(false)}
//             >
//               {about.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setAboutPagesOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/services"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Services
//           </Link>

//           {/* Events Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setEventPages(true)}
//             onMouseLeave={() => setEventPages(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap">
//               <span>Events</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   eventPages ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 eventPages
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setEventPages(true)}
//               onMouseLeave={() => setEventPages(false)}
//             >
//               {events.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setEventPages(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/membership"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Membership
//           </Link>

//           {/* Facilities Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setFacilitiesOpen(true)}
//             onMouseLeave={() => setFacilitiesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap">
//               <span>Facilities</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   facilitiesOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 facilitiesOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setFacilitiesOpen(true)}
//               onMouseLeave={() => setFacilitiesOpen(false)}
//             >
//               {facilities.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setFacilitiesOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/golf-course"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Golf Course
//           </Link>

//           {/* Content Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setContentOpen(true)}
//             onMouseLeave={() => setContentOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap">
//               <span>Content</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   contentOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 contentOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setContentOpen(true)}
//               onMouseLeave={() => setContentOpen(false)}
//             >
//               {content.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setContentOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/sponsors"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Sponsors
//           </Link>

//           <Link
//             to="/contact"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2 whitespace-nowrap"
//           >
//             Contact
//           </Link>

//           {isLoggedIn ? (
//             <Link
//               to="/dashboard"
//               className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold whitespace-nowrap"
//             >
//               Dashboard
//             </Link>
//           ) : (
//             <Link
//               to="/login"
//               className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold whitespace-nowrap"
//             >
//               Login
//             </Link>
//           )}
//         </nav>

//         {/* Mobile Menu Button */}
//         <button
//           className="lg:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors duration-200"
//           onClick={handleMenuToggle}
//           aria-label="Toggle menu"
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//           >
//             {menuOpen ? (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             ) : (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M4 6h16M4 12h16M4 18h16"
//               />
//             )}
//           </svg>
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div
//         className={`lg:hidden fixed inset-0 top-full w-full h-[calc(100vh-90px)] bg-gradient-to-b from-gray-900 to-black text-white transition-transform duration-300 ease-in-out ${
//           menuOpen ? "transform -translate-y-full" : ""
//         }`}
//       >
//         {/* Scrollable Container */}
//         <div className="h-full overflow-y-auto pb-20">
//           <div className="px-4 sm:px-6 py-4 space-y-0">
//             <Link
//               onClick={handleLinkClick}
//               to="/"
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             >
//               Home
//             </Link>

//             {/* Mobile About Us Dropdown */}
//             <div className="border-b border-gray-700">
//               <button
//                 className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
//                 onClick={() => setAboutPagesOpen(!aboutPagesOpen)}
//               >
//                 <span>About Us</span>
//                 <span className="transform transition-transform duration-200">
//                   {aboutPagesOpen ? "−" : "+"}
//                 </span>
//               </button>
//               {aboutPagesOpen && (
//                 <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
//                   {about.map(({ label, path }, i) => (
//                     <Link
//                       onClick={handleLinkClick}
//                       key={i}
//                       to={path}
//                       className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
//                     >
//                       {label}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <Link
//               onClick={handleLinkClick}
//               to="/services"
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             >
//               Services
//             </Link>

//             {/* Mobile Events Dropdown */}
//             <div className="border-b border-gray-700">
//               <button
//                 className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
//                 onClick={() => setEventPages(!eventPages)}
//               >
//                 <span>Events</span>
//                 <span className="transform transition-transform duration-200">
//                   {eventPages ? "−" : "+"}
//                 </span>
//               </button>
//               {eventPages && (
//                 <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
//                   {events.map(({ label, path }, i) => (
//                     <Link
//                       onClick={handleLinkClick}
//                       key={i}
//                       to={path}
//                       className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
//                     >
//                       {label}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <Link
//               onClick={handleLinkClick}
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//               to="/membership"
//             >
//               Membership
//             </Link>

//             {/* Mobile Facilities Dropdown */}
//             <div className="border-b border-gray-700">
//               <button
//                 className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
//                 onClick={() => setFacilitiesOpen(!facilitiesOpen)}
//               >
//                 <span>Facilities</span>
//                 <span className="transform transition-transform duration-200">
//                   {facilitiesOpen ? "−" : "+"}
//                 </span>
//               </button>
//               {facilitiesOpen && (
//                 <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
//                   {facilities.map(({ label, path }, i) => (
//                     <Link
//                       onClick={handleLinkClick}
//                       key={i}
//                       to={path}
//                       className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
//                     >
//                       {label}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <Link
//               onClick={handleLinkClick}
//               to="/golf-course"
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             >
//               Golf Course
//             </Link>

//             {/* Mobile Content Dropdown */}
//             <div className="border-b border-gray-700">
//               <button
//                 className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
//                 onClick={() => setContentOpen(!contentOpen)}
//               >
//                 <span>Content</span>
//                 <span className="transform transition-transform duration-200">
//                   {contentOpen ? "−" : "+"}
//                 </span>
//               </button>
//               {contentOpen && (
//                 <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
//                   {content.map(({ label, path }, i) => (
//                     <Link
//                       onClick={handleLinkClick}
//                       key={i}
//                       to={path}
//                       className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
//                     >
//                       {label}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <Link
//               onClick={handleLinkClick}
//               to="/sponsors"
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             >
//               Sponsors
//             </Link>

//             <Link
//               onClick={handleLinkClick}
//               to="/contact"
//               className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             >
//               Contact
//             </Link>

//             <div className="pt-6 border-t border-gray-700">
//               {isLoggedIn ? (
//                 <Link
//                   onClick={handleLinkClick}
//                   to="/dashboard"
//                   className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
//                 >
//                   Dashboard
//                 </Link>
//               ) : (
//                 <Link
//                   onClick={handleLinkClick}
//                   to="/login"
//                   className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
//                 >
//                   Login
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/WithName.png";
import { AuthContext } from "../context/AuthContext";

const about = [
  { label: "Our Mission", path: "/mission" },
  { label: "Our Vision", path: "/vision" },
  { label: "Our Leadership Team", path: "/leadership-team" },
  { label: "Our History", path: "/about" },
];

// Events nav is now a single "Upcoming Events" link - Present/Past Events
// moved under Content > Event Galleries.
// const events = [
//   { label: "Upcoming Events", path: "/upcoming-events" },
//   { label: "Present Events", path: "/present-events" },
//   { label: "Past Events", path: "/past-events" },
// ];

const content = [
  // Retired in favor of event-based photo galleries.
  // { label: "Image Gallery", path: "/image-gallery" },
  { label: "Event Galleries", path: "/event-galleries" },
  { label: "Video Gallery", path: "/video-gallery" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutPagesOpen, setAboutPagesOpen] = useState(false);
  // Events is now a single link - no dropdown state needed.
  // const [eventPages, setEventPages] = useState(false);
  const [contentOpen, setContentOpen] = useState(false);

  const { isLoggedIn } = useContext(AuthContext);

  // Close all dropdowns when menu closes
  const closeAllDropdowns = () => {
    setAboutPagesOpen(false);
    // setEventPages(false);
    setContentOpen(false);
  };

  const handleMenuToggle = () => {
    const newMenuOpen = !menuOpen;
    setMenuOpen(newMenuOpen);
    if (!newMenuOpen) {
      closeAllDropdowns();
    }
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    closeAllDropdowns();
  };

  return (
    <header className="fixed w-full z-50 left-0 top-0">
      {/* Main Header - Changed to light greenish background */}
      <div className="bg-gradient-to-r from-green-100 to-green-200 w-full backdrop-blur-lg px-4 sm:px-6 md:px-12 lg:px-16 py-4 md:py-3 flex items-center justify-between border-b border-green-300">
        {/* Logo - Properly aligned */}
        <Link
          to="/"
          className="flex-shrink-0 flex items-center"
          onClick={handleLinkClick}
        >
          <img
            src={logo}
            alt="RGCC Logo"
            className="h-12 sm:h-14 md:h-16 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation - centered independently of the logo/login button
        so the link count changing doesn't throw off the overall balance */}
        <nav className="hidden lg:flex items-center justify-center flex-1 space-x-6 xl:space-x-8 text-gray-800 font-medium">
          <Link
            to="/"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Home
          </Link>

          {/* About Us Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setAboutPagesOpen(true)}
            onMouseLeave={() => setAboutPagesOpen(false)}
          >
            <button className="flex items-center space-x-1 text-gray-800 hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap">
              <span>About Us</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  aboutPagesOpen ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                aboutPagesOpen
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setAboutPagesOpen(true)}
              onMouseLeave={() => setAboutPagesOpen(false)}
            >
              {about.map(({ label, path }, i) => (
                <Link
                  onClick={() => setAboutPagesOpen(false)}
                  key={i}
                  to={path}
                  className="block hover:text-green-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/facilities"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Facilities
          </Link>

          {/* Events Dropdown - replaced by a single Upcoming Events link;
          Present/Past Events moved under Content > Event Galleries.
          <div
            className="relative group"
            onMouseEnter={() => setEventPages(true)}
            onMouseLeave={() => setEventPages(false)}
          >
            <button className="flex items-center space-x-1 text-gray-800 hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap">
              <span>Events</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  eventPages ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                eventPages
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setEventPages(true)}
              onMouseLeave={() => setEventPages(false)}
            >
              {events.map(({ label, path }, i) => (
                <Link
                  onClick={() => setEventPages(false)}
                  key={i}
                  to={path}
                  className="block hover:text-green-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
          */}
          <Link
            to="/upcoming-events"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Events
          </Link>

          <Link
            to="/membership"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Membership
          </Link>

          <Link
            to="/golf-course"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Golf Course
          </Link>

          {/* Content Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setContentOpen(true)}
            onMouseLeave={() => setContentOpen(false)}
          >
            <button className="flex items-center space-x-1 text-gray-800 hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap">
              <span>Content</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  contentOpen ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-56 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                contentOpen
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setContentOpen(true)}
              onMouseLeave={() => setContentOpen(false)}
            >
              {content.map(({ label, path }, i) => (
                <Link
                  onClick={() => setContentOpen(false)}
                  key={i}
                  to={path}
                  className="block hover:text-green-600 hover:translate-x-1 transition-all duration-200 font-normal whitespace-nowrap"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Sponsors - temporarily hidden from the site.
          <Link
            to="/sponsors"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Sponsors
          </Link>
          */}

          <Link
            to="/contact"
            className="hover:text-green-700 transition-colors duration-200 py-2 whitespace-nowrap"
          >
            Contact
          </Link>
        </nav>

        {/* Pinned to the right edge, separate from the nav links so it stays
        put regardless of how many links are in the nav block above */}
        <div className="hidden lg:flex items-center flex-shrink-0">
          {isLoggedIn ? (
            <Link
              to="/dashboard"
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold whitespace-nowrap"
            >
              Dashboard
            </Link>
          ) : (
            <Link
              to="/login"
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold whitespace-nowrap"
            >
              Login
            </Link>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-gray-800 p-2 hover:bg-green-200 rounded-lg transition-colors duration-200"
          onClick={handleMenuToggle}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={2}
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu - Kept the dark background for contrast */}
      <div
        className={`lg:hidden fixed inset-0 top-full w-full h-[calc(100vh-90px)] bg-gradient-to-b from-gray-900 to-black text-white transition-transform duration-300 ease-in-out ${
          menuOpen ? "transform -translate-y-full" : ""
        }`}
      >
        {/* Scrollable Container */}
        <div className="h-full overflow-y-auto pb-20">
          <div className="px-4 sm:px-6 py-4 space-y-0">
            <Link
              onClick={handleLinkClick}
              to="/"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Home
            </Link>

            {/* Mobile About Us Dropdown */}
            <div className="border-b border-gray-700">
              <button
                className="flex justify-between w-full text-left py-4 hover:text-green-400 transition-colors duration-200"
                onClick={() => setAboutPagesOpen(!aboutPagesOpen)}
              >
                <span>About Us</span>
                <span className="transform transition-transform duration-200">
                  {aboutPagesOpen ? "−" : "+"}
                </span>
              </button>
              {aboutPagesOpen && (
                <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
                  {about.map(({ label, path }, i) => (
                    <Link
                      onClick={handleLinkClick}
                      key={i}
                      to={path}
                      className="block py-3 hover:text-green-400 transition-colors duration-200 border-b border-gray-600"
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              onClick={handleLinkClick}
              to="/facilities"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Facilities
            </Link>

            {/* Mobile Events Dropdown - replaced by a single Upcoming Events
            link; Present/Past Events moved under Content > Event Galleries.
            <div className="border-b border-gray-700">
              <button
                className="flex justify-between w-full text-left py-4 hover:text-green-400 transition-colors duration-200"
                onClick={() => setEventPages(!eventPages)}
              >
                <span>Events</span>
                <span className="transform transition-transform duration-200">
                  {eventPages ? "−" : "+"}
                </span>
              </button>
              {eventPages && (
                <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
                  {events.map(({ label, path }, i) => (
                    <Link
                      onClick={handleLinkClick}
                      key={i}
                      to={path}
                      className="block py-3 hover:text-green-400 transition-colors duration-200 border-b border-gray-600"
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            */}
            <Link
              onClick={handleLinkClick}
              to="/upcoming-events"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Events
            </Link>

            <Link
              onClick={handleLinkClick}
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
              to="/membership"
            >
              Membership
            </Link>

            <Link
              onClick={handleLinkClick}
              to="/golf-course"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Golf Course
            </Link>

            {/* Mobile Content Dropdown */}
            <div className="border-b border-gray-700">
              <button
                className="flex justify-between w-full text-left py-4 hover:text-green-400 transition-colors duration-200"
                onClick={() => setContentOpen(!contentOpen)}
              >
                <span>Content</span>
                <span className="transform transition-transform duration-200">
                  {contentOpen ? "−" : "+"}
                </span>
              </button>
              {contentOpen && (
                <div className="ml-4 mt-1 space-y-0 text-sm text-gray-300">
                  {content.map(({ label, path }, i) => (
                    <Link
                      onClick={handleLinkClick}
                      key={i}
                      to={path}
                      className="block py-3 hover:text-green-400 transition-colors duration-200 border-b border-gray-600"
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Sponsors - temporarily hidden from the site.
            <Link
              onClick={handleLinkClick}
              to="/sponsors"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Sponsors
            </Link>
            */}

            <Link
              onClick={handleLinkClick}
              to="/contact"
              className="block py-4 hover:text-green-400 transition-colors duration-200 border-b border-gray-700"
            >
              Contact
            </Link>

            <div className="pt-6 border-t border-gray-700">
              {isLoggedIn ? (
                <Link
                  onClick={handleLinkClick}
                  to="/dashboard"
                  className="block w-full bg-green-500 hover:bg-green-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
                >
                  Dashboard
                </Link>
              ) : (
                <Link
                  onClick={handleLinkClick}
                  to="/login"
                  className="block w-full bg-green-500 hover:bg-green-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
